import { connect } from 'react-redux';

import { COOKIE_SIGNIN_EMAIL } from 'Component/MyAccountSignIn/MyAccountSignIn.config';
import { BILLING_URL, SHIPPING_URL } from 'Route/Checkout/Checkout.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MyAccountSignInContainer as SourceMyAccountSignInContainer
} from 'SourceComponent/MyAccountSignIn/MyAccountSignIn.container';
import BrowserDatabase from 'Util/BrowserDatabase';
import transformToNameValuePair from 'Util/Form/Transform';
import history from 'Util/History';
import { getErrorMessage } from 'Util/Request';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';
import { appendWithStoreCode, getQueryParam } from 'Util/Url';

/** @namespace PeggysagePwa/Component/MyAccountSignIn/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace PeggysagePwa/Component/MyAccountSignIn/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/MyAccountSignIn/Container */
export class MyAccountSignInContainer extends SourceMyAccountSignInContainer {
    state = {
        ...this.state,
        emailValue: ''
    };

    componentDidMount() {
        this.setEmailValue();
    }

    /**
     * Retrieve email from cookie if exists
     */
    setEmailValue() {
        const { emailValue } = this.props;

        this.setState({
            emailValue: emailValue || BrowserDatabase.getItem(COOKIE_SIGNIN_EMAIL) || ''
        });
    }

    /**
     * Override: use emailValue from state instead of props
     */
    containerProps() {
        const { emailValue } = this.state;

        return {
            ...super.containerProps(),
            emailValue
        };
    }

    /**
     * Override: redirect to given url provided as GET param (returnUrl)
     * @param form
     * @param fields
     * @returns {Promise<void>}
     */
    async onSignInSuccess(form, fields) {
        const {
            signIn,
            showNotification,
            onSignIn,
            setLoadingState,
            totals: { is_virtual },
            isCheckout
        } = this.props;

        const {
            isSignIn
        } = this.state;

        setLoadingState(true);
        const fieldPairs = transformToNameValuePair(fields);

        if (!isSignIn) {
            this.setState({ isSignIn: true });

            try {
                await signIn(fieldPairs);

                // Return url
                const returnUrl = getQueryParam('returnUrl', location);
                if (returnUrl) {
                    history.push(`${ returnUrl }${ location.hash }`);
                } else {
                    onSignIn();
                }
            } catch (error) {
                showNotification('error', getErrorMessage(error));
                this.setState({ isSignIn: false });
            } finally {
                setLoadingState(false);
            }
        }

        setLoadingState(false);

        // Save email in cookie
        const {
            remember_me, // equals to 'remember_me' when checked
            email
        } = fieldPairs;

        if (remember_me) {
            BrowserDatabase.setItem(email, COOKIE_SIGNIN_EMAIL, ONE_MONTH_IN_SECONDS);
        } else {
            BrowserDatabase.deleteItem(COOKIE_SIGNIN_EMAIL);
        }

        // Redirections
        if (is_virtual && isCheckout) {
            history.push({ pathname: appendWithStoreCode(BILLING_URL) });
        } else if (!is_virtual && isCheckout) {
            history.push({ pathname: appendWithStoreCode(SHIPPING_URL) });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountSignInContainer);
